import type { BlockDef } from '../../prop-types.ts'
import { EMPTY_TEXT } from '../../text.ts'

/** A section heading. Its `level` is a SEMANTIC choice, not a size — see the field's note. */
export const heading: BlockDef = {
  type: 'heading',
  v: 1,
  label: { en: 'Heading', ar: 'عنوان' },
  scope: 'page',
  description: 'A section title, optionally with a short line of context underneath.',
  whenToUse: 'To open a section of a page that is not the hero — "Our menu", "What we do", "Where to find us".',
  whenNotToUse: 'At the very top of a landing page — that is a Hero. For body copy — that is a Text section.',
  variants: [
    { value: 'start', label: { en: 'Aligned to the start', ar: 'محاذاة للبداية' } },
    { value: 'centered', label: { en: 'Centred', ar: 'موسّط' } },
    { value: 'eyebrow', label: { en: 'With a label above', ar: 'مع تسمية أعلاه' } },
  ],
  fields: [
    { key: 'eyebrow', label: { en: 'Small label above', ar: 'تسمية صغيرة أعلاه' }, type: { kind: 'text' }, default: EMPTY_TEXT },
    { key: 'heading', label: { en: 'Heading', ar: 'العنوان' }, type: { kind: 'text' }, default: EMPTY_TEXT, requiredForPublish: true },
    { key: 'subheading', label: { en: 'Supporting line', ar: 'سطر داعم' }, type: { kind: 'text' }, default: EMPTY_TEXT },
    {
      key: 'level',
      label: { en: 'Outline level', ar: 'مستوى العنوان' },
      // ⚠️ THIS IS AN ACCESSIBILITY FIELD, NOT A SIZE PICKER, and labelling it "Big/Medium/Small"
      // would be the whole bug: a customer choosing "small" because it looks nicer would silently
      // break the page's outline for a screen reader. The renderer sizes headings from the TEMPLATE;
      // this only decides whether the tag is <h2> or <h3>.
      type: {
        kind: 'enum',
        options: [
          { value: '2', label: { en: 'Section', ar: 'قسم' } },
          { value: '3', label: { en: 'Sub-section', ar: 'قسم فرعي' } },
        ],
      },
      default: '2',
    },
  ],
}
